import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ColorSetting } from './color-setting';
import { CornersSetting } from './corners-setting';
import { Setting } from './setting';

type Props = {
  backgroundColorFieldProps: Omit<ComponentProps<typeof ColorSetting>, 'label'>;
  cornersFieldProps: ComponentProps<typeof CornersSetting>;
  textColorFieldProps: Omit<ComponentProps<typeof ColorSetting>, 'label'>;
};

export const ButtonSetting = ({ backgroundColorFieldProps, cornersFieldProps, textColorFieldProps }: Props) => {
  const { t } = useTranslation('content-composer');

  return (
    <Setting title={t('Button')}>
      <CornersSetting {...cornersFieldProps} />
      <ColorSetting {...backgroundColorFieldProps} label={t('Button Color')} />
      <ColorSetting {...textColorFieldProps} label={t('Text Color')} />
    </Setting>
  );
};
